import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  external?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  size = 'md',
  external = false,
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex w-full items-center justify-center rounded-lg border-2 border-brand-carbon bg-brand-yellow font-display uppercase leading-tight tracking-wide text-brand-carbon text-center shadow-[0_5px_0_0_var(--brand-carbon)] transition-[transform,box-shadow,background-color] duration-150 ease-soft hover:bg-[#ffc61a] active:translate-y-[3px] active:shadow-[0_2px_0_0_var(--brand-carbon)]';
  const sizes: Record<string, string> = {
    md: 'px-4 py-2.5 text-lg',
    lg: 'px-5 py-3 text-xl sm:text-2xl'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`${base} ${sizes[size]} ${className}`} data-id="element-184" data-mp="1360h2z1eott1">
      {children}
    </a>;
}